/**
 * 手机登录
 */
import React, { Component } from "react";
import loading from 'c-up-loading';
import notification from 'c-notification';

import Countries from './countries';
import CountryCodes from './countryCode';

import NumberUtil from '../../lib/util/number';
import lang from '../../lang';

import UserLogin from '../profile/login';
import {hex_md5} from '../../base/md5';
import Cache from 'c-cache';
import CountryView from '../select-country/country-view';
import CheckRegister from '../thirdparty-login/thirdparty/check';
import Register from '../thirdparty-login/thirdparty/register';
import SmsSendCode from './sendcode/index';
import UserSetPwd from './findpwd/index';
import Timer from 'c-timer';

const cache = new Cache({
    prefix: 'pcuplive'
});

const bindType = 1;
class PhoneLogin extends Component {
	static defaultProps = {
		phone: ''
	}
	constructor(props){
		super(props);
		let initState = {
			showSelect: true,
			userProcess: props.userProcess || 'login',
			phone: props.phone,
			progress: props.progress || 'inputPhone',
			disVerifyCode: false
		};
		let state = Object.assign(initState,props);
		this.state = state;
	}
	setInitState(state){
        this.setState(state,()=>{
        	UP.Global.DA.add({
                eventName: 'phoneLoginProgerss_'+this.state.progress,
                action: 'show'
            });
        });
    }
	componentDidMount(){
		if(this.state.progress == 'inputPhone' &&  this.props.userProcess == 'login'){
			UP.Global.DA.add({
                eventName: 'phoneLoginProgerss_'+this.state.progress,
                action: 'show'
            });
		}
		let self = this;
		let el = $(this.refs.areaCode);

		el.on({
			// mouseenter: function(e) {
			// 	// self.setState({
			// 	// 	showSelect: true
			// 	// });
			// },
			// mouseleave: function(e) {				
			// 	self.setState({
			// 		showSelect: false
			// 	});
			// },
			click: function(e) {				
				self.setState({
					showSelect: true
				});
			}
		});

		$(document.body).on('click', (e)=>{
            let el = $(e.target);
            let showSelect = false;
            
            if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
                showSelect = true;
            }
            this.setState({
                showSelect
            });
        });
	}

	componentWillUnmount(){
   		$(document.body).off('click');
        this.timer && this.timer.destroy();
   	}

	getProfileForRegister = (data)=>{
		let self = this;
		this.login(data);
	}
	getProfileForNoRegister = (data)=>{
		let self = this;
        let registerPromise = this.register(data);

        registerPromise.done((data) => {
        	self.isFetching = false;
            // 手机注册成功，真实用户  开启验证模式
            loading.hide();
            self.setState({
            	userProcess: 'sendPhoneSuccess'
            });
            UP.Global.DA.add({
                eventName: 'phoneRegisterSuccess',
                action: 'show'
            });

            fbq('track', 'emailRegisterSuccess', { oauthtype: 'email'});

            cache.setCache('isRegisterRealUser', true);
            UP.Global.writeUserInfo(data);
            $.channel.emit('loginSuccess', data);
            
        });
        
        registerPromise.fail((dataWrap)=>{
            loading.hide();

            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            } else if(dataWrap.code == 4099){
            	notification.simple(lang.template('验证码输入错误'));	
            } else {
            	notification.simple(lang.template('帐号或密码错误'));	
            }
            
        });

	}

	/*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered = (data)=>{
        let promise = new CheckRegister({
            bindType: bindType,
            thirdId: this.state.areaCode + data.phone
        }).promise;

        return promise;
    }

    register = (data)=>{
        let { phone, password, smsCode } = data;
        let requestData = {
        	bindType: bindType,
            mobilePhone: this.state.areaCode + phone,
            password: hex_md5(password),
        };
        if(smsCode){
        	requestData.smsCode = smsCode;
        }
        let promise = new Register(requestData).promise;

        return promise;
    }

    login = (data)=>{
    	let {phone, password} = data;
        let promise = new UserLogin({
			loginType: 2,
	        bindType: 1,
	        thirdId: this.state.areaCode + phone,
	        password: hex_md5(password),
	        pushType: 10,
		}).promise;

        promise.done(function(data){
        	UP.Global.DA.add({
                eventName: 'phoneLoginSuccess',
                action: 'show'
            });
        	// 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

			$.channel.emit("loginSuccess", data);	

        	self.isFetching = false;
        });

        promise.fail(function(dataWrap){
        	
        	if (dataWrap) {
        		if (dataWrap.code == 4130) {
        			notification.simple(lang.template('帐号或密码错误'));	
        		} else if (dataWrap.code == 4119) {
                	notification.simple('device forbidden');
            	}
        	}
        	loading.hide();
        	
        });

        return promise;
    }

	handleSubmit = (e)=>{
		let phone = this.refs.phone.value.trim();
		if (!this.state.code) {
            notification.simple(lang.template('选择国家或地区'));
            this.setState({
                showSelect: true
            });
            return;
        }
        let progress = this.state.progress;
        switch(progress){
        	case 'inputPhone': 
        		if(this.verifyPhoneNum()){
        			let registerData = {
        				phone
        			};
        			let isRegistered = this.checkRegistered(registerData);
        			isRegistered.done((registered) => {
			            if (registered) {
			                //已注册  进入登录
			                this.setState({
			                	progress: 'inputPwd'
			                });
			            } else {
			                // 未注册 进入注册
			                if(this.state.userProcess == 'login'){
			                	// notification.simple(lang.template('该手机号未被注册'));
			                	loading.hide();
			                	$.channel.emit('phoneRegister',{
									areaCode: this.state.areaCode,
									inputValuePlusCode: this.state.inputValuePlusCode,
									phone: this.state.phone,
									progress: 'register',
									code: this.state.code
								});
			                }else{
			                	this.getProfileForNoRegister(registerData);
			                }
			                
			            }
			        });
        		}
        		break;
        	case 'inputPwd': 
        		if(this.verifyPwd()){

					let password = this.refs.password.value.trim();
        			let registerData = {
        				phone: phone,
        				password
        			};
        			this.getProfileForRegister(registerData);
        		}
        		break;
        	case 'register':
				if(this.verifyPwd() && this.verifySmsCode()){

					let password = this.refs.password.value.trim();
					let smsCode = this.refs.smsCode.value.trim();
					let registerData = {
						phone,
						smsCode,
						password
					};
					this.getProfileForNoRegister(registerData);
				}
        		break;
        	case 'findPwd':
        		let password = this.refs.password.value.trim();
				let smsCode = this.refs.smsCode.value.trim();
				if(this.verifyPwd() && this.verifySmsCode()){
					let registerData = {
						phone,
						smsCode,
						password
					};
					this.findPhoneLoginPwd(registerData);
				}
        		break;
        }
	}
	findPhoneLoginPwd(data){
		let promise = new UserSetPwd({
				bindType: bindType,
				thirdId: this.state.areaCode +  data.phone,
				verifyCode: data.smsCode,
				password: hex_md5(data.password)
			}).promise;
		promise.done((data)=>{
			UP.Global.DA.add({
                eventName: 'phoneLoginProgerss_'+this.state.progress+'Success',
                action: 'show'
            });
			notification.simple(lang.template('登录密码设置成功'));
			this.setState({
				progress: 'inputPwd'
			},()=>{
				$.channel.emit('phoneLogin',{
					areaCode: this.state.areaCode,
					inputValuePlusCode: this.state.inputValuePlusCode,
					phone: this.state.phone,
					progress: this.state.progress,
					code: this.state.code
				});
			});
		});
		promise.fail((data)=>{
			UP.Global.DA.add({
                eventName: 'phoneLoginProgerss_'+this.state.progress+'fail',
                action: 'show'
            });
			if(data.code == 4099){

				notification.simple(lang.template('验证码输入错误'));
			}else{
				notification.simple(lang.template('登录密码设置失败'));
			}
		})
	}
	verifyPhoneNum(){
		let phone = this.refs.phone.value.trim();

		if (phone == '') {
			notification.simple(lang.template('请输入手机号码'));
			return false;
		}
		this.setState({
			phone
		});
		return true;
	}
	verifyPwd(){

		let password = this.refs.password.value.trim();
		if(password == ''){
			notification.simple(lang.template('请输入登录密码'));
			return false;
		}
		return true; 
	}
	verifySmsCode(){
		let smsCode = this.refs.smsCode.value.trim();
		if(smsCode.length != 6){
			return false;
		}
		return true;
	}
	handleSelectCountry=()=>{
		if (this.state.showSelect) {
			return;
		}

		this.setState({
			showSelect: true
		});
	}

	onSelectOption(data) {
		if (!data.inputValuePlusCode) {
			data.inputValuePlusCode = lang.template('国家/地区');
		}
		this.setState( Object.assign( {showSelect: false}, data));
	}
	sendCode = (module)=>{
		let self = this;
		if (this.state.disVerifyCode) {
            return;
        }
		let phone = this.refs.phone.value.trim();
		let promise = new SmsSendCode({
			mobilePhone: this.state.areaCode + phone,
			module: 'register'
		}).promise;
		promise.done((data)=>{
			notification.simple(lang.template("验证码已发送"));
			let second = $('[data-second=second]');
			second.removeClass('hidden');
			self.setState({
                disVerifyCode: true
            });

            let timer = self.timer = new Timer({
                remainTime : '60',
                isDoubleBit: true,
                selector : {
                    second : '[data-second]'
                }
            });

            self.timer.on('end' , function () {
            	second.addClass('hidden');
                self.setState({
                    disVerifyCode: false
                });
            });
		});
		promise.fail((data)=>{
			notification.simple(lang.template("验证码发送失败"));
		});
	}
	forgetPwd = ()=>{

		this.setState({
			progress: 'findPwd'
		},()=>{
			$.channel.emit('phoneFindPwd',{
				areaCode: this.state.areaCode,
				inputValuePlusCode: this.state.inputValuePlusCode,
				phone: this.state.phone,
				progress: this.state.progress,
				code: this.state.code

			});
		});
	}
	

    render() {
    	let phoneInput = (
    		<div className="login-form-item tel-item" ref="areaCode">
    			<div className="input-wrap arrow" onClick={this.handleSelectCountry}>
					<div className="input">
					{this.state.inputValuePlusCode}&lrm;
					</div>
				</div>
				<div className="input-wrap">
					<input 
						className="input"
						ref="phone"
						type="text" 
						placeholder={lang.template('请输入手机号码')}
						defaultValue={this.state.phone}
					/>
				</div>
				<CountryView visible={this.state.showSelect} selectOption={this.onSelectOption.bind(this)} ref="countryView"/>
    		</div>

    	);
    	if(this.state.progress != "inputPhone"){
    		phoneInput = (
    		<div className="login-form-item phone-show">
    				<em className="tip"><i className="num">{lang.template('手机号:')}</i></em>
    				<em className="phoneNum">{this.state.inputValuePlusCode} {this.state.phone}</em>
    				<input 
						className="input hidden"
						ref="phone"
						type="text" 
						placeholder={lang.template('请输入手机号码')}
						defaultValue={this.state.phone}
					/>
    		</div>
    	);
    	}
    	
    	let pwdInput = (
    			<div className="login-form-item">
        			<div className="input-wrap input-split-wrap">
						<input 
							className="input input-short"
							ref="password"
							type="password"
							placeholder={lang.template('请输入登录密码')}
							defaultValue=""
						/>
	    				<div className="sub-btn" onClick={this.forgetPwd}>{lang.template('忘记密码')}</div>
					</div>
        		</div>);
    	if(this.state.progress == 'findPwd' || this.state.progress == 'register'){
    		pwdInput = (
    			<div className="login-form-item">
        			<div className="input-wrap">
						<input 
							className="input"
							ref="password"
							type="password"
							placeholder={lang.template('请输入登录密码')}
							defaultValue=""
						/>

					</div>
        		</div>);
    	}
    	let VerifyCodeText;

        if (this.state.disVerifyCode) {
            VerifyCodeText = "s";
        } else {
            VerifyCodeText = lang.template('发送验证码');
        }

    	let smsCodeInput = (
    			<div className="login-form-item">
        			<div className="input-wrap input-split-wrap">
						<input 
							className="input smsCode"
							ref="smsCode"
							type="smsCode"
							placeholder={lang.template('输入验证码')}
						/>
					
					{
						this.state.progress == 'findPwd'?(
							<div className={`sub-btn ${this.state.disVerifyCode ? 'sending': ''}`} onClick={()=>{this.sendCode('findPassword')}}><em data-second="second"></em>{VerifyCodeText}</div>
						) : (
							<div className={`sub-btn ${this.state.disVerifyCode ? 'sending': ''}`}  onClick={()=>{this.sendCode('register')}}><em data-second="second"></em>{VerifyCodeText}</div>
						)
					}
					</div>
					
        		</div>
    		);
    	let {userProcess,progress} = this.state;
    	
		switch (progress){
			case 'inputPhone': 
				return (
					<div className="phone-login">
						<div className="input-box">
        					{phoneInput}
        				</div>
			    		<div className="phone-login-btn" onClick={this.handleSubmit}>
							{lang.template('确定')}
						</div>
			    	</div>

				);

				break;
			case 'inputPwd':
				return(
					<div className="phone-login">
						<div className="input-box">
		    				{phoneInput}
		    				{pwdInput}
	    				</div>
			    		<div className="phone-login-btn" onClick={this.handleSubmit}>
							{lang.template('确定')}
						</div>
			    	</div>
		    	);
		    	break;
		    case 'register': 
		    	return(
					<div className="phone-login">

						<div className="input-box">
		    				{phoneInput}
		    				{smsCodeInput}
		    				{pwdInput}
	    				</div>
			    		<div className="phone-login-btn" onClick={this.handleSubmit}>
							{lang.template('确定')}
						</div>
			    	</div>
		    	);
				
		    	break;	
		    case 'findPwd':
		    	return(
					<div className="phone-login">
						<div className="input-box">
		    				{phoneInput}
		    				{smsCodeInput}
		    				{pwdInput}
	    				</div>
			    		<div className="phone-login-btn" onClick={this.handleSubmit}>
							{lang.template('确定')}
						</div>
			    	</div>
		    	);
		    	break;

		}
    	

        return (
        	<div className="phone-login">
        		<div className="phone-login-btn" onClick={this.handleSubmit}>
					{lang.template('登录')}
				</div>
        	</div>
        )
    }
}

export default PhoneLogin;


// WEBPACK FOOTER //
// ./js/component/phone-login/index.js